import React from 'react'
import PropTypes from 'prop-types'

const PlusIcon = ({
  width,
  height,
  title,
  color,
  programmeHead,
  page,
}) => (
  <svg
    className="plusClass"
    width={width}
    height={height}
    viewBox={title === 'My list' ? '0 0 21 21' : '0 0 26 19'}
    fill={color}
  >
    <title>{title}</title>
    {// eslint-disable-next-line no-nested-ternary
      title === 'My list'
        ? <path d="M0 11.8128H9.1875V21H11.8125V11.8128H21V9.18772H11.8125V0.000510637L9.1875 0V9.18772H0V11.8128Z" />
        : (programmeHead ? <path d="M8.6 15.8998L4.4 11.6998L3 13.0998L8.6 18.6998L20.6 6.6998L19.2 5.2998L8.6 15.8998Z" />
          : <path d="M10.3431 18.4558L0.44365 8.55635L2.61432 6.38568L10.3139 14.0853L23.6996 0.699607L25.8991 2.89992L12.5138 16.2852L10.3431 18.4558Z" />)
    }
    {!programmeHead ? (
      <style jsx="true">{`
.plusClass{
    box-sizing: border-box;
    padding: 5px;
    border-radius: 100px;
    border: 1.755px solid ${color};
}

.plusClass:hover{
    background: ${page === 'TVGuide' ? '' : 'white'};
    fill: ${page === 'TVGuide' ? '' : 'black !important'};
}`}
      </style>
    ) : (
      <style jsx="true">{`.plusClass{
      box-sizing: none;
      padding: 0px;
      border-radius: 0px;
      border: none;

}`}
      </style>
    )}
  </svg>

)

PlusIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string,
  color: PropTypes.string,
  programmeHead: PropTypes.bool,
  page: PropTypes.string,
}

PlusIcon.defaultProps = {
  width: 20,
  height: 20,
  title: 'My list',
  color: 'currentColor',
  programmeHead: false,
  page: '',
}

export default PlusIcon
